export const NAVS = ['home', 'reports'];
